function checkIE(userAgent) {
    return (userAgent === null || userAgent === void 0 ? void 0 : userAgent.indexOf('MSIE ')) > -1 || (userAgent === null || userAgent === void 0 ? void 0 : userAgent.indexOf('Trident/')) > -1;
}
function checkSafari(userAgent) {
    return (userAgent === null || userAgent === void 0 ? void 0 : userAgent.indexOf('AppleWebKit')) !== -1 && (userAgent === null || userAgent === void 0 ? void 0 : userAgent.indexOf('Chrome')) === -1;
}

export { checkIE, checkSafari };
//# sourceMappingURL=checkBrowser.js.map
